// Helpers for working with appointment dates on the admin calendar.

// Returns a local Date for an appointment, preferring the confirmed scheduled_at,
// falling back to the customer's preferred_date. Returns null if unparseable.
export function getApptDate(appt) {
  const raw = appt.scheduled_at || appt.preferred_date || "";
  const m = String(raw).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return null;
  const [, y, mo, d] = m;
  return new Date(Number(y), Number(mo) - 1, Number(d));
}

export function sameDay(a, b) {
  return (
    a &&
    b &&
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  );
}

// Default value for a datetime-local input (YYYY-MM-DDTHH:MM)
export function defaultScheduleValue(appt) {
  const m = String(appt.preferred_date || "").match(/^\d{4}-\d{2}-\d{2}/);
  const datePart = m ? m[0] : new Date().toISOString().slice(0, 10);
  return `${datePart}T09:00`;
}

// Pretty time from scheduled_at for display in lists
export function prettySchedule(scheduledAt) {
  if (!scheduledAt) return "";
  const dt = new Date(scheduledAt);
  if (isNaN(dt)) return scheduledAt;
  return dt.toLocaleString(undefined, {
    weekday: "short",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}
